import { Injectable, Pipe, PipeTransform } from '@angular/core';
import reverse from 'lodash-es/reverse';

const reverseFn = reverse as (array: any[]) => any[];
@Injectable()
@Pipe({
    name: 'reverse', pure: false,
    standalone: true
})
export class Reverse implements PipeTransform {
  transform<T>(input: T[]): T[];
  transform(input: any): any;
  transform(input: any): any {
    if (Array.isArray(input)) {
      return reverseFn([...input]);
    }
    return input;
  }
}
